import { ecbrRequest } from '../../request/ecbrRequest'

export const signUp = {
  create: async (payload) => ecbrRequest.post('/company/signup', payload),
  createBrand: async (payload) =>
    ecbrRequest.post('/company/signup/new-brand', payload)
}
